import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AuthentificationService } from "src/app/core/services/authentication.service";
import { catchError, map, of, switchMap, tap } from "rxjs";
import {
    USER_ACCOUNT_RECOVERY,
    USER_ACCOUNT_RECOVERY_FAILED,
    USER_ACCOUNT_RECOVERY_SUCCESS,
    USER_LOGIN, USER_LOGIN_FAILED, USER_LOGIN_SUCCESS,
    USER_REGISTRATION,
    USER_REGISTRATION_FAILED,
    USER_REGISTRATION_RESULT
} from "../actions/user-authentification.actions";

import { DialogService } from "src/app/core/services/dialog.service";
import { Router } from "@angular/router";
import { HIDE_EXPIRING_MBC_NOTIFIACTION, HIDE_EXPIRING_MBC_NOTIFIACTION_FAILED, HIDE_EXPIRING_MBC_NOTIFIACTION_SUCCESS, SAVE_USER_INFO, SAVE_USER_INFO_FAILED, SAVE_USER_INFO_SUCCESS } from "../actions/user.actions";
import { SpinnerService } from "src/app/core/services/spinner.service";
import { PreloaderService } from "src/app/core/services/preloader.service";
import { ROUTES } from "src/app/core/constants/routes";
import { UserInfo } from "src/app/core/models/entites/userInfo";

@Injectable()
export class AuthEffects {

    login$ = createEffect(() =>
        this.actions$.pipe(
            ofType(USER_LOGIN),
            switchMap((action) =>
                this.authService.login(action.username, action.password).pipe(
                    map((response) => USER_LOGIN_SUCCESS({ loggedUser: response.data })),
                    catchError((response) => of(USER_LOGIN_FAILED({ response: response })))
                )
            )
        )
    );

    loginSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(USER_LOGIN_SUCCESS),
            tap((action) => {
                this.spinnerService.hideSpinner();
                this.preloaderService.triggerPreloader();
                sessionStorage.setItem("UserInfo", JSON.stringify(action.loggedUser));
                this.router.navigate([ROUTES.BETTING_TASKS]);
            }),
        ), { dispatch: false });

    authorizationFailed$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                USER_LOGIN_FAILED,
                USER_REGISTRATION_FAILED),
            tap(() => {
                this.spinnerService.hideSpinner();
            })
        ), { dispatch: false });

    register$ = createEffect(() =>
        this.actions$.pipe(
            ofType(USER_REGISTRATION),
            switchMap((action) =>
                this.authService.register(action.registeredUser).pipe(
                    map((response) => USER_REGISTRATION_RESULT({ response: response })),
                    catchError((response) => of(USER_REGISTRATION_FAILED({ response: response })))
                ))
        )
    );

    registerSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(USER_REGISTRATION_RESULT),
            tap((action) => {
                this.spinnerService.hideSpinner();
                if (action.response.ibetResponseStatus == "OK") {
                    this.spinnerService.hideSpinner();
                    this.router.navigate([ROUTES.VERIFICATION]);
                }
            })
        ), { dispatch: false });

    saveUserInfo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SAVE_USER_INFO),
            switchMap((action) =>
                this.authService.saveUserInfo(action.modifiedUser).pipe(
                    map((modifiedUser) => SAVE_USER_INFO_SUCCESS({ modifiedUser })),
                    catchError((response) => of(SAVE_USER_INFO_FAILED({ message: response.error.message })))
                )
            )
        )
    );

    saveUserInfoSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SAVE_USER_INFO_SUCCESS),
            tap(() => {
                this.spinnerService.hideSpinner();
                this.dialogService.openConfirmation(undefined, "Izmene uspešno sačuvane!");
            })
        ), { dispatch: false });


    recoveryUserAccount$ = createEffect(() =>
        this.actions$.pipe(
            ofType(USER_ACCOUNT_RECOVERY),
            switchMap((action) =>
                this.authService.recover(action.email).pipe(
                    map((message) => USER_ACCOUNT_RECOVERY_SUCCESS({ message })),
                    catchError((response) => of(USER_ACCOUNT_RECOVERY_FAILED({ message: response.error.message })))
                )
            )
        )
    );

    recoveryUserAccountSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(USER_ACCOUNT_RECOVERY_SUCCESS),
            tap(() => {
                this.spinnerService.hideSpinner();
                this.router.navigateByUrl(ROUTES.PASSWORD_RECOVERY_SUBMIT);
            })
        ), { dispatch: false });

    recoveryUserAccountFailed$ = createEffect(() =>
        this.actions$.pipe(
            ofType(
                USER_ACCOUNT_RECOVERY_FAILED,
                SAVE_USER_INFO_FAILED),
            tap((action) => {
                this.spinnerService.hideSpinner();
                this.dialogService.openError("Greška!", action.message);
            })
        ), { dispatch: false });


    hideExpiringMbcNotification$ = createEffect(() =>
        this.actions$.pipe(
            ofType(HIDE_EXPIRING_MBC_NOTIFIACTION),
            tap(() => {
                this.spinnerService.showSpinner();
            }),
            switchMap((action) =>
                this.authService.hideExpiringMbcNotification(action.clientId)
                    .pipe(
                        map(() => HIDE_EXPIRING_MBC_NOTIFIACTION_SUCCESS()),
                        catchError(() => of(HIDE_EXPIRING_MBC_NOTIFIACTION_FAILED()))
                    )
            )
        )
    );

    hideExpiringMbcNotificationSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(HIDE_EXPIRING_MBC_NOTIFIACTION_SUCCESS),
            tap(() => {
                const userInfo = JSON.parse(sessionStorage.getItem("UserInfo")!) as UserInfo;
                if (userInfo) {
                    userInfo.expiringMbcNotificationType = "none";
                    sessionStorage.setItem("UserInfo", JSON.stringify(userInfo));
                    this.dialogService.closeDialog();
                }
                this.spinnerService.hideSpinner();
            })
        ), { dispatch: false });

    hideExpiringMbcNotificationFailed$ = createEffect(() =>
        this.actions$.pipe(
            ofType(HIDE_EXPIRING_MBC_NOTIFIACTION_FAILED),
            tap(() => {
                this.spinnerService.hideSpinner();
            })
        ), { dispatch: false });

    constructor(
        private actions$: Actions,
        private dialogService: DialogService,
        private authService: AuthentificationService,
        private router: Router,
        private spinnerService: SpinnerService,
        private preloaderService: PreloaderService) { }
}